import type { Pending } from './ProposalCards';
import type { TripPending } from './TripProposalCards';

// The pending kinds TripProposalCard renders (ADR-0027 phase 2, ADR-0028).
export function isTripPending(p: Pending): p is TripPending {
  return ['activity_update', 'packing_items', 'note', 'ticket', 'meal', 'grocery', 'entity_update', 'entity_delete', 'operation'].includes(p.kind);
}
